import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";
import type { Nullable } from "shared/types";

import type TvChannel from "./TvChannel";
import type TvProgramAiring from "./TvProgramAiring";

@Model()
class TvClip extends ApplicationRecord {
  static jsonapiType = "tv_clips";

  @Attr() archivedAt: Nullable<string>;

  @Attr({ persist: false }) channelId: number;

  @Attr({ persist: false }) createdAt: string;

  @Attr({ persist: false }) endTime: number;

  @BelongsTo() programAiring: TvProgramAiring;

  @BelongsTo() source: TvChannel;

  @Attr({ persist: false }) startTime: number;

  @Attr({ persist: false }) tvProgramAiringId: number;

  @Attr({ persist: false }) url: string;
}

export default TvClip;
